import axios from 'axios'

export const getNews = (params) => {
  return axios.get('/notification/news', { params })
}

export const markAsRead = (id) => {
  return axios.put(`/notification/broadcast/${id}/markAsRead`)
}
